/* The comment thread under a post.
 *
 * A thin wrapper: the rendering lives in features/comments/CommentThread, which
 * Prayer Requests use too. This file only says WHERE the comments come from.
 *
 * Only mounted when someone opens it — otherwise every post on screen would
 * fetch its comments, which is a request per card for content nobody asked for.
 */
import { CommentThread as Thread } from '@/features/comments/CommentThread'
import { useAddComment, useComments } from '@/api/queries'

export function CommentThread({
  postId,
  focusComment,
}: {
  postId: string
  focusComment?: string | null
}) {
  const comments = useComments(postId)
  const addComment = useAddComment(postId)

  const items = comments.data?.pages.flatMap((p) => p.items) ?? []

  return (
    <Thread
      comments={items}
      isLoading={comments.isLoading}
      hasMore={comments.hasNextPage}
      onLoadMore={() => comments.fetchNextPage()}
      isLoadingMore={comments.isFetchingNextPage}
      isSending={addComment.isPending}
      focusId={focusComment}
      onSend={(body, parentId) =>
        addComment.mutate({ body, parent_id: parentId })
      }
    />
  )
}
